import { Station } from "src/tmc-yard/client/model/station";
import { StationSet } from "src/tmc-yard/client/model/station-set";

export class StationSelection {

    station: Station;
    stationSet: StationSet;

    constructor(selection?: any) {
        if (selection != null) {
            this.station = selection.station;
            this.stationSet = selection.stationSet;
        }
    }
}